import { render, staticRenderFns } from "./editEmail.vue?vue&type=template&id=678622bd&scoped=true&"
import script from "./editEmail.vue?vue&type=script&lang=js&"
export * from "./editEmail.vue?vue&type=script&lang=js&"
import style0 from "./editEmail.vue?vue&type=style&index=0&id=678622bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678622bd",
  null
  
)

export default component.exports